import {
  Content as ContentPrimitive,
  Portal as PortalPrimitive,
  Close as ClosePrimitive,
} from "@radix-ui/react-dialog";
import cn from "../../../utils/cn";
import { Overlay } from "./overlay";
import { forwardRef } from "react";
import { X } from "react-feather";

export const Content = forwardRef<
  React.ElementRef<typeof ContentPrimitive>,
  React.ComponentPropsWithoutRef<typeof ContentPrimitive> & {
    showCloseButton?: boolean;
  }
>(({ className, children, showCloseButton = true, ...props }, ref) => (
  <PortalPrimitive>
    <Overlay />
    <ContentPrimitive
      ref={ref}
      className={cn(
        "fixed left-[50%] top-[50%] bg-indigo-25 z-50 flex flex-col max-w-[95vw] max-h-[80vh] translate-x-[-50%] translate-y-[-50%] gap-5 bg-white rounded-[0.375rem] p-5 shadow-xl duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]",
        className
      )}
      {...props}
    >
      {children}
      {showCloseButton && (
        <ClosePrimitive
          asChild
          className="text-indigo-600 absolute top-5 right-5 transition-opacity hover:opacity-100 focus:outline-hidden disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-[0.875rem]"
        >
          <X />
        </ClosePrimitive>
      )}
    </ContentPrimitive>
  </PortalPrimitive>
));

Content.displayName = ContentPrimitive.displayName;

export default Content;
